// SPE Begin - Panther and Fargo service route rewrite
// These entities are served by microservices, not the main backend.
// JHipster generates services with 'api/' prefix, so we rewrite them here
// to avoid losing the custom URLs on every JDL regeneration.
const PANTHER_ENTITIES = [
  'bookable-events',
  'calendar-events',
  'calendars',
  'configs',
  'report-categories',
  'report-groups',
  'reports',
  'societies',
  'society-equipments',
  'society-groups',
  'sql-queries',
  'widget-categories',
  'widget-galleries',
  'widget-notification-centers',
  'widgets',
];

const FARGO_ENTITIES: string[] = [];

export const rewriteServiceUrl = (url: string): string => {
  for (const entity of PANTHER_ENTITIES) {
    if (url === `api/${entity}` || url.startsWith(`api/${entity}?`) || url.startsWith(`api/${entity}/`)) {
      return url.replace('api/', 'services/panther/api/');
    }
  }
  for (const entity of FARGO_ENTITIES) {
    if (url === `api/${entity}` || url.startsWith(`api/${entity}?`) || url.startsWith(`api/${entity}/`)) {
      return url.replace('api/', 'fargo/api/');
    }
  }
  return url;
};
// SPE End - Panther and Fargo service route rewrite
